import { AbstractControl } from '@angular/forms';
import { SECURITY_NUMBER_NUMBER_OF_DIGITS } from '@shared/models/trust.model';

export const isSSNNotMatchLength = (ssn: string): boolean => {
  const ssnStripped = ssn.replace(/_/g, '').replace(/-/g, '');
  return ssnStripped.length !== SECURITY_NUMBER_NUMBER_OF_DIGITS;
};

export const validateSecurityNumber = (control: AbstractControl): { required: boolean } => {
  return isSSNNotMatchLength(control.value) ? { required: true } : null;
};
